module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Star-4e3482a96428d819540633dad8940c62.svg";